
<div class="container">
    <div class="box">
       <img src="../../../assets/images/notfound.jpg" alt="" width="450px">
    </div>
 </div>
